var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner",
      staticStyle: {
        padding: "5px 0",
        width: "fit-content",
        "min-width": "1000px",
        height: "100%"
      }
    },
    [
      _c("div", { staticClass: "app-main-inner-row section" }, [
        _c(
          "div",
          [
            _c(
              "el-form",
              { attrs: { "label-width": "120px", "label-position": "left" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c("div", {
                          staticStyle: {
                            "background-color": "#57D1FF",
                            width: "12px",
                            height: "30px",
                            "margin-right": "5px"
                          }
                        }),
                        _c(
                          "label",
                          {
                            staticStyle: {
                              "font-width": "bold",
                              "font-size": "15px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_NatureOfSales"))
                            )
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Sales") } },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "1" },
                              model: {
                                value: _vm.txtOwnerId,
                                callback: function($$v) {
                                  _vm.txtOwnerId = $$v
                                },
                                expression: "txtOwnerId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_BranchCompany")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "2" },
                              model: {
                                value: _vm.txtBranchId,
                                callback: function($$v) {
                                  _vm.txtBranchId = $$v
                                },
                                expression: "txtBranchId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_OwningDept")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "3" },
                              model: {
                                value: _vm.txtDepartment,
                                callback: function($$v) {
                                  _vm.txtDepartment = $$v
                                },
                                expression: "txtDepartment"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_TeamLeader")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "4" },
                              model: {
                                value: _vm.txtGroupLeader,
                                callback: function($$v) {
                                  _vm.txtGroupLeader = $$v
                                },
                                expression: "txtGroupLeader"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AssignmentDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: true,
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                no: "5"
                              },
                              model: {
                                value: _vm.quotationClient.assignDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.quotationClient,
                                    "assignDate",
                                    $$v
                                  )
                                },
                                expression: "quotationClient.assignDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_DaysOfSleep")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "6" },
                              model: {
                                value: _vm.quotationClient.sleepDays,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.quotationClient,
                                    "sleepDays",
                                    $$v
                                  )
                                },
                                expression: "quotationClient.sleepDays"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_DaysFromContractSigned"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "7" },
                              model: {
                                value: _vm.quotationClient.signedDays,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.quotationClient,
                                    "signedDays",
                                    $$v
                                  )
                                },
                                expression: "quotationClient.signedDays"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_DaysToContractExpiry"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "8" },
                              model: {
                                value: _vm.quotationClient.dueTime2,
                                callback: function($$v) {
                                  _vm.$set(_vm.quotationClient, "dueTime2", $$v)
                                },
                                expression: "quotationClient.dueTime2"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                staticStyle: { width: "1200px" },
                attrs: { "label-width": "120px", "label-position": "left" }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c("div", {
                          staticStyle: {
                            "background-color": "#57D1FF",
                            width: "12px",
                            height: "30px",
                            "margin-right": "5px"
                          }
                        }),
                        _c(
                          "label",
                          {
                            staticStyle: {
                              "font-width": "bold",
                              "font-size": "15px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CustomerProperty"))
                            )
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_ClientNo") }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "9" },
                              model: {
                                value: _vm.quotationClient.clientId,
                                callback: function($$v) {
                                  _vm.$set(_vm.quotationClient, "clientId", $$v)
                                },
                                expression: "quotationClient.clientId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ChineseName"),
                              required: ""
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "240px" },
                              attrs: { disabled: !_vm.isEditing, no: "10" },
                              model: {
                                value: _vm.quotationClient.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.quotationClient, "name", $$v)
                                },
                                expression: "quotationClient.name"
                              }
                            }),
                            _c(
                              "el-tooltip",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t(
                                    "Partners.industrialAndCommercialInformationQuery"
                                  ),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                      "margin-bottom": "5px",
                                      cursor: "pointer",
                                      "vertical-align": "middle",
                                      display: "inline-block"
                                    },
                                    attrs: {
                                      href: _vm.tianYanChaUrl,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "20px",
                                        height: "20px"
                                      },
                                      attrs: { src: "/static/eyeInTheSky.png" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_EnglishName"),
                              required: ""
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.isEditing, no: "11" },
                              model: {
                                value: _vm.quotationClient.englishName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.quotationClient,
                                    "englishName",
                                    $$v
                                  )
                                },
                                expression: "quotationClient.englishName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Abbreviation")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                maxlength: 100,
                                no: "shortName"
                              },
                              model: {
                                value: _vm.quotationClient.shortName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.quotationClient,
                                    "shortName",
                                    $$v
                                  )
                                },
                                expression: "quotationClient.shortName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ScaleOfCompany")
                              }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  min: 1,
                                  max: 999999999999,
                                  precision: 0,
                                  "controls-position": "right",
                                  no: "12"
                                },
                                model: {
                                  value: _vm.quotationClient.companySize,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotationClient,
                                      "companySize",
                                      $$v
                                    )
                                  },
                                  expression: "quotationClient.companySize"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            { staticStyle: { "padding-left": "10px" } },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_People")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_RegisteredCapital"
                                )
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { flex: "1", width: "100%" },
                                    attrs: {
                                      disabled: !_vm.isEditing,
                                      min: 1,
                                      max: 999999999999,
                                      "controls-position": "right",
                                      no: "13"
                                    },
                                    model: {
                                      value:
                                        _vm.quotationClient.registeredCapital,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.quotationClient,
                                          "registeredCapital",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "quotationClient.registeredCapital"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "padding-left": "10px",
                                        "font-size": "8px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_TenThousandYuan"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_CustomerType")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                  size: "mini",
                                  no: "14"
                                },
                                model: {
                                  value: _vm.quotationClient.companyTypeCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotationClient,
                                      "companyTypeCode",
                                      $$v
                                    )
                                  },
                                  expression: "quotationClient.companyTypeCode"
                                }
                              },
                              _vm._l(_vm.crmCustomerTypeList, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ClientStatus")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: !(
                                    _vm.isEditing &&
                                    parseInt(
                                      _vm.quotationClient.customerStatusCode
                                    ) !==
                                      parseInt(
                                        _vm.CrmCustomerConstants
                                          .STAGE_COOPERATION.code
                                      )
                                  ),
                                  placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                  size: "mini",
                                  no: "15"
                                },
                                model: {
                                  value: _vm.quotationClient.customerStatusCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotationClient,
                                      "customerStatusCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "quotationClient.customerStatusCode"
                                }
                              },
                              _vm._l(
                                parseInt(
                                  _vm.quotationClient.customerStatusCode
                                ) ===
                                  parseInt(
                                    _vm.CrmCustomerConstants.STAGE_COOPERATION
                                      .code
                                  )
                                  ? _vm.CrmCustomerConstants.CUSTOMER_STATUS
                                  : _vm.CrmCustomerConstants
                                      .CUSTOMER_STATUS_NO_COOPERATION,
                                function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label:
                                        _vm.$store.getters.language === "zh"
                                          ? item.chineseName
                                          : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_AssessedClientLevel"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                  size: "mini",
                                  no: "16"
                                },
                                model: {
                                  value: _vm.quotationClient.customerLevelCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotationClient,
                                      "customerLevelCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "quotationClient.customerLevelCode"
                                }
                              },
                              _vm._l(_vm.customerLevelCode, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_DifficultyIndex")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                  size: "mini",
                                  no: "17"
                                },
                                model: {
                                  value: _vm.quotationClient.overcomeLevelCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotationClient,
                                      "overcomeLevelCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "quotationClient.overcomeLevelCode"
                                }
                              },
                              _vm._l(_vm.overcomeLevelCode, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showSourceType,
                                expression: "showSourceType"
                              }
                            ],
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SourceOfClient")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: true,
                                  placeholder: _vm.$t(
                                    "CargoMsg.Cargo_SalesFreeHand"
                                  ),
                                  size: "mini",
                                  no: "18"
                                },
                                model: {
                                  value: _vm.quotationClient.sourceType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotationClient,
                                      "sourceType",
                                      $$v
                                    )
                                  },
                                  expression: "quotationClient.sourceType"
                                }
                              },
                              _vm._l(
                                _vm.CrmCustomerConstants.SOURCE_TYPE_GRID,
                                function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label:
                                        _vm.$store.getters.language === "zh"
                                          ? item.chineseName
                                          : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Competitor")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.isEditing, no: "21" },
                              model: {
                                value: _vm.quotationClient.competitorCompany,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.quotationClient,
                                    "competitorCompany",
                                    $$v
                                  )
                                },
                                expression: "quotationClient.competitorCompany"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_CustomerContactChannel"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                  size: "mini",
                                  no: "19"
                                },
                                model: {
                                  value:
                                    _vm.quotationClient.customerContactChannel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotationClient,
                                      "customerContactChannel",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "quotationClient.customerContactChannel"
                                }
                              },
                              _vm._l(_vm.customerContactChannelList, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_FirstContactDate"),
                              required: ""
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: true,
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                no: "20"
                              },
                              model: {
                                value: _vm.quotationClient.firstMeetDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.quotationClient,
                                    "firstMeetDate",
                                    $$v
                                  )
                                },
                                expression: "quotationClient.firstMeetDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-form",
              { attrs: { "label-width": "120px", "label-position": "left" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c("div", {
                          staticStyle: {
                            "background-color": "#57D1FF",
                            width: "12px",
                            height: "30px",
                            "margin-right": "5px"
                          }
                        }),
                        _c(
                          "label",
                          {
                            staticStyle: {
                              "font-width": "bold",
                              "font-size": "15px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CustomerAddress"))
                            )
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: false,
                          "label-width": "120px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_CountryRegion")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    disabled: !_vm.isEditing,
                                    filterable: "",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Country,
                                    "tag-name":
                                      _vm.$store.getters.language === "zh"
                                        ? "chineseName"
                                        : "name",
                                    "default-value":
                                      _vm.quotationClient.country,
                                    no: "22"
                                  },
                                  on: { parentCallBack: _vm.selectCargoItem }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: !_vm.isEditing,
                          inline: true,
                          "label-width": "60px"
                        }
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 16 } },
                          [
                            _c("cargo-area", {
                              attrs: {
                                filterable: "",
                                "allow-create": false,
                                country: _vm.quotationClient.country,
                                province: _vm.quotationClient.province,
                                city: _vm.quotationClient.city,
                                district: _vm.quotationClient.districts,
                                "select-width": 120,
                                no: "23"
                              },
                              on: {
                                "update:province": function($event) {
                                  return _vm.$set(
                                    _vm.quotationClient,
                                    "province",
                                    $event
                                  )
                                },
                                "update:city": function($event) {
                                  return _vm.$set(
                                    _vm.quotationClient,
                                    "city",
                                    $event
                                  )
                                },
                                "update:district": function($event) {
                                  return _vm.$set(
                                    _vm.quotationClient,
                                    "districts",
                                    $event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_StreetAddress"),
                              required: ""
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.isEditing, no: "24" },
                              model: {
                                value: _vm.quotationClient.address,
                                callback: function($$v) {
                                  _vm.$set(_vm.quotationClient, "address", $$v)
                                },
                                expression: "quotationClient.address"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                type: "textarea",
                                rows: 4,
                                no: "25"
                              },
                              model: {
                                value: _vm.quotationClient.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.quotationClient, "remarks", $$v)
                                },
                                expression: "quotationClient.remarks"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }